import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  Divider,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import InvoiceItems from "./invoice/items";
import InvoiceCommunication from "./invoice/communication";
import InvoiceSystemInformation from "./invoice/systemInformation";
import InvoiceCustom from "./invoice/custom";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import { getTransactionDepositDetail } from "../../api/deposit";
import {
  GridComp12,
  GridComp4,
  GridComp6,
} from "../../components/GridComponents";
import { CustomCheckBox } from "../../components/CheckboxComp";
import { makeStyles } from "@mui/styles";
import SalesOrderRelatedRecords from "./invoice/related-records";
import InvoiceCharges from "./invoice/charges";
import InvoiceShipping from "./invoice/shipping";
import InvoiceAccounting from "./invoice/accounting";
import InvoiceRelationship from "./invoice/relationship";
import InvoiceAvaTax from "./invoice/ava-tax";
import DepositTab from "./deposit/depositTab";
import DepositCommunication from "./deposit/communication";
import DepositSystemInformation from "./deposit/systemInformation";
import DepositCustom from "./deposit/custom";
import DepositsEft from "./deposit/eft";
const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function TransactionTypeDeposit() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const params = useParams();
  const [rowData, setRowData] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndexRelationship, setTabIndexRelationship] = useState(0);
  const [tabIndexApproveList, setTabIndexApproveList] = useState(0);
  const [tabIndexAvaTax, setTabIndexAvaTax] = useState(0);
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  /*----------------End Tabs-----------------*/
  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);
  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionDepositDetail(user.token, {
        tranid: params.docNo,
        // type: pageDetail.path,
      });
      setData(data.data);
      setRowData(data.data.details[0]);
      setLoading(false);

      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);

      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
         <Typography component="h4" fontWeight={500} className="pageTitle">
            Deposit
          </Typography>
          <Typography component="p" style={{ marginBottom:"4px" }}>
            <span className="para-no" > <strong>{rowData.tranid}</strong></span>{" "}
            
          </Typography>
      {/*Primary Information*/}
      {/* {rowData.map((el, index) => ( */}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <>
            <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={12}>
                <Grid container className="mb-2">
                  <GridComp4 title={"DEPOSIT #"} data={rowData.tranid} />
                  <GridComp4 title={"CURRENCY"} data={rowData.currency} />
                  <GridComp4
                    title={"POSTING PERIOD"}
                    data={rowData.posting_period}
                  />
                  <GridComp4
                    title={"PC/PROJECT"}
                    data={rowData.pc_project}
                  />
                  <GridComp4 title={"BANK ACCOUNT"} data={rowData.account} />
                  <GridComp4
                    title={"EXCHANGE RATE"}
                    data={rowData.exchange_rate}
                  />
                  <GridComp4 title={"MEMO"} data={rowData.memo} />
                  <GridComp4 title={"AMOUNT"} data={rowData.amount} />
                  <GridComp4 title={"DATE"} data={rowData.date} />
                  <CustomCheckBox
                    title={"TO BE PRINTED"}
                    data={rowData.to_be_printed}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        </Box>
      </Box>
      {/* ))} */}

      {/*Classification*/}
      {/* {rowData.map((el, index) => ( */}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={12}>
              <Grid container className="mb-2">
                <GridComp4 title={"SUBSIDIARY"} data={rowData.subsidiary} />
                <GridComp4 title={"DEPARTMENT"} data={rowData.department} />
                <GridComp4 title={"SERVICE LINE"} data={rowData.service_line} />
                <GridComp4 title={"LOCATION"} data={rowData.location} />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* ))} */}
      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className={`${classes.spacedTabs} tabs-bkg`}
            // className="tabs-bkg"
          >
            <Tab label="Deposits" />
            <Tab label="Communication" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
          </Tabs>
          {/*------------Deposits------------*/}
          <TabPanel value={tabIndex} index={0}>
          {tabIndex === 0 &&     <DepositTab />}
          </TabPanel>

          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 &&   <DepositCommunication />}
          </TabPanel>

          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && <DepositSystemInformation />}
          </TabPanel>
          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 &&      <DepositCustom />}
          </TabPanel>
          {/*-------------EFT-----------*/}
          <TabPanel value={tabIndex} index={4}>
          {tabIndex === 4 &&    <DepositsEft tabIndex={tabIndex} />}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
